import React from 'react';

const DocumentNewIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...rest}>
      <path d="M8.6665 1.33331H3.99984C3.64622 1.33331 3.30708 1.47379 3.05703 1.72384C2.80698 1.97389 2.6665 2.31302 2.6665 2.66665V13.3333C2.6665 13.6869 2.80698 14.0261 3.05703 14.2761C3.30708 14.5262 3.64622 14.6666 3.99984 14.6666H11.9998C12.3535 14.6666 12.6926 14.5262 12.9426 14.2761C13.1927 14.0261 13.3332 13.6869 13.3332 13.3333V5.99998M8.6665 1.33331L13.3332 5.99998M8.6665 1.33331V5.99998H13.3332" stroke="#2857FC" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" {...rest} />
    </svg>
  );
};

export default DocumentNewIcon;